export default "__VITE_ASSET__Csnh0Wcz__"